import { useMemo, useRef, useCallback } from 'react'

type Noop = (...args: any[]) => any

const useMemoizedFn = <T extends Noop = Noop>(fn: T) => {
  const fnRef = useRef<T>(fn)

  fnRef.current = useMemo(() => fn, [fn])

  return useCallback<Noop>((...args) => fnRef.current.apply(undefined, args), []) as T
}

export default useMemoizedFn
